import React from 'react';
import {
  isBooleanControl,
  rankWith,
  optionIs,
  and
} from '@jsonforms/core';
import { withJsonFormsControlProps } from '@jsonforms/react';
import { Unwrapped } from '@jsonforms/material-renderers';
import FormHelperText from '@mui/material/FormHelperText';

import parse from 'html-react-parser';
const { MaterialBooleanControl } = Unwrapped;


export const checkBoxLabelHtml = props => {
  const label = parse(`${props.label}${props.required ? '*' : ''}`);

  return (
    <>
      <MaterialBooleanControl {...props} label={<p style={{ textAlign: 'justify' }}>{label}</p>} />
      <FormHelperText error={true}>{props.errors}</FormHelperText>
    </>
  );
};

export const checkBoxLabelHtmlTester = rankWith(
  1000,
  and(
    isBooleanControl,
    optionIs('parseHtml', true)
  )
);
export default withJsonFormsControlProps(checkBoxLabelHtml);
